import React from 'react'
import { t } from 'i18next'
import { UseFormReturn } from 'react-hook-form'
import { GridItem } from '../../components/common/grid/GridItem'
import { ControlledTextInput } from '../../components/common/inputs/TextInput'
import { Title } from '../../components/common/texts/Title'
import { ControlledZipInput } from '../../components/common/inputs/ControlledZipInput'
import { ControlledPhoneInput } from '../../components/common/inputs/ControlledPhoneInput'
import { OrganisationWithUserAccountsDTO } from '../../api/schemas/schema'
import { Grid } from '../../components/common/grid/Grid'
import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
   container: {
      marginTop: tokens.spacingVerticalXXL,
      '@media (max-width: 1007px)': {
         display: 'flex',
         flexDirection: 'column',
      },
   },
})

type OrganisationInvoiceFormProps = {
   organisationForm: UseFormReturn<OrganisationWithUserAccountsDTO, any, undefined>
}

export const OrganisationInvoiceForm = ({ organisationForm }: OrganisationInvoiceFormProps) => {
   const { control } = organisationForm
   const classes = useStyles()
   return (
      <Grid className={classes.container}>
         <GridItem size={'12/12'}>
            <Title as="h5">{t('BillingData')}</Title>
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'organisation.invoiceName'} label={t('CompanyName')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'organisation.invoiceReference'} label={t('InvoiceReference')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'organisation.invoiceAddress'} label={t('InvoiceAddress')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledZipInput required control={control} name={'organisation.postalCode'} label={t('PostalCode')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledTextInput required control={control} type="text" name={'organisation.county'} label={t('County')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledPhoneInput required control={control} name={'organisation.phoneNumber'} label={t('PhoneNumber')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledTextInput required control={control} type="email" name={'organisation.email'} label={t('Email')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput multiline control={control} type="text" name={'organisation.otherInvoiceDetails'} label={t('OtherInvoiceDetails')} />
         </GridItem>
      </Grid>
   )
}
